import { z } from 'zod';
import { digestSchema } from '../hashing/hash.js';
/**
 * A file sitting in Blob staging, before HR has approved anything.
 *
 * Defined once so the portal upload endpoint and the pdf-lib artifact writer produce the
 * identical shape — two producers of the same record is exactly how a routing handler ends
 * up with a field one of them never sets.
 *
 * Staging is deliberately not the system of record (ADR-009): nothing reaches the records or
 * restricted account until a human approves it, and an abandoned upload expires where it lies.
 */
export const stagedBlobRefSchema = z.object({
    uploadId: z.string().min(1),
    container: z.string().min(1),
    blobName: z.string().min(1),
    byteLength: z.number().int().nonnegative(),
    contentType: z.string().min(1),
    /**
     * What the person called it. Displayed to HR and used to name the routed file; never
     * used to build a path, because it is attacker-controlled text.
     */
    originalFileName: z.string().min(1),
    /** Of the bytes, so the routed file can be proved identical to what was uploaded. */
    sha256: digestSchema,
    uploadedAt: z.string().datetime(),
});
//# sourceMappingURL=staged.js.map